<template>
    <div class="btn-box">
        <p class="zhezhao"></p>
        <el-button class="btn more" @click="handleClickMore">更多{{typeName[type]}}</el-button>
    </div>
</template>

<script>
    export default {
        name: "more-btn",
        props: {
            type: String,
            navId: [String, Number]
        },
        computed: {
            typeName(){
                return {
                    template: '模版',
                    scenes: '场景',
                    image: '图片',
                    audio: '音频',
                    animation: '动画',
                    video: '视频',
                    game: '游戏',
                    tools: '工具'
                }
            }
        },
        methods: {
            handleClickMore(){
                this.$emit('onMoreBtn', {navId: this.navId})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .btn-box{
        position: relative;

        .zhezhao{
            position: absolute;
            left: -22px;
            top: -57px;
            width: 304px;
            height: 128px;
            pointer-events: none;
            z-index: 5;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
        }
    }
    .btn.more{
        width: 210px;
        font-size: 14px;
        background-color: #fed800;
        border-radius: 20px;
        border: none;
        color: #323232;
        margin-top: 10px;
        margin-bottom: 50px;
        position: relative;
        z-index: 10;

        height:40px;
        background: linear-gradient(180deg,rgba(255,188,40,1) 0%,rgba(255, 120, 56,1) 100%);
        box-shadow:0px 4px 6px 0px rgba(134,75,0,0.02),0px 2px 9px 0px rgba(255,182,25,0.54);
        border-radius:20px;
        color: white;

        &:active{
            opacity: .8;
        }
    }
    .btn-box /deep/ .el-button:focus{
        color: white !important;
    }
</style>
